//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import {
        wrongAnswerCourse, todayAnswerPrize
    }
    from '@/api/ajax.js'
    export default {
        name: 'wrong',
        data() {
            return {
                rightNum: 0,
                courseObj: {},
                integral: -1
            }
        },
        methods: {
            jump() {
                this.$sa.re_activity({
                  name:'答题拼图',
                  event_type:'点击错题正解'
                })
                this.courseObj.id && this.$sa.setSaSession_href(this.$route,`//wx.yxvzb.com/html/newWechat.html#/courseDetail/${this.courseObj.id}`)

            }
        },
        watch: {

        },
        computed: {},
        components: {},
        // beforeRouteEnter (to , from ,next){
        //   if(from.name != 'play'){
        //     Vue.prototype.$vux.toast.show({
        //       text: '每天仅有一次答题机会,明天再来参加吧',
        //       type: 'text',
        //       width: '7rem'
        //     })
        //   }
        // },
        created() {
          setTimeout(()=>{
            if (!this.$route.query.first) {
                this.$vux.toast.show({
                    text: '每天仅有一次答题机会,明天再来参加吧',
                    type: 'text',
                    width: '7rem'
                })
            }
          },1000)
            wrongAnswerCourse({
                questionId: this.$route.query.wrongId
            }).then(res => {
                this.courseObj = res.data.data[0]
            })
            todayAnswerPrize().then(res => {
                this.integral = res.data.integral
                console.log(this.integral)
            })
            this.rightNum = this.$route.query.rightNum || 0
        },
        beforeRouteLeave(to, from, next) {

            if (to.name == 'play') {
                next({
                    name: 'home'
                })
            } else {
                next(true)
            }
        }

    }



// WEBPACK FOOTER //
// ./src/page/Wrong/index.vue